<template src="./SchedulePendency.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
    mixins: [mixins],
    name: "schedule-pendency",
    props: ["patientId"],
    data: () => ({
        window: {
            width: 0,
            height: 0
    },
        showWebTable: true,
        waitingMatch: [],
        specialities: [],
        popupConfirma: false,
        confirmSchedule: "",
        clinicAddress: "",
        cancellation: false,
        indexPendency: null
    }),
    created: function() {
        const vm = this;
        window.addEventListener("resize", vm.handleResize);
        vm.handleResize();
    },
    destroyed: function() {
        const vm = this;
        window.removeEventListener("resize", vm.handleResize);
    },
    mounted() {
        const vm = this;
        vm.init();
    },
    methods: {
        init() {
            const vm = this;
            vm.getPendency();
        },
        handleResize() {
            const vm = this;
            vm.window.width = window.innerWidth;
            vm.window.height = window.innerHeight;
            if (vm.window.width <= 670) {
                vm.showWebTable = false;
            } else {
                vm.showWebTable = true;
            }
        },
        getPendency() {
            const vm = this;
            this.axios
            .get(vm.$store.state.filooServer + "schedules/patient/" + vm.$props.patientId,{
                headers: {
                    Authorization: vm.$session.get("bearer")
                },
                options: {
                    page: 0,
                    size: 20,
                    sort: ["id", "desc"]
                }
            }
            )
            .then(function(response) {
                vm.specialities = response.data.content;
            });
        },
        openCancel(index) {
            const vm = this;
            vm.indexPendency = index;
            vm.cancellation = true;
        },

        popConfirma(index) {
            const vm = this;
            vm.clinicAddress =
            index.match.clinic.address.street +
            " " +
            index.match.clinic.address.number +
            " " +
            index.match.clinic.address.city +
            " " +
            index.match.clinic.address.state +
            " " +
            index.match.clinic.address.zipcode;
            vm.confirmSchedule = index;
            vm.popupConfirma = true;
        },

        openClinic() {
            const vm = this;
            var url = "https://www.google.com/maps/place/" + vm.clinicAddress;
            window.open(url, "_blank");
        },

        aceitaSolicitacao(id) {
            const vm = this;
            this.axios
            .put(
                vm.$store.state.filooServer + "schedules/" + id + "/accept-patient",
                {},
                {
                headers: {
                    Authorization: vm.$session.get("bearer")
                }
                }
            )
            .then(function(response) {
                if (response.status === 200) {
                    vm.$swal("Sucesso!", "Consulta aceita", "success");
                    vm.popupConfirma = false;
                    vm.getPendency();
                } else {
                    vm.popupConfirma = false;
                    vm.$swal("Erro ao aceitar", "Saldo insuficiente");
                }
            })
            .catch(function() {
                vm.popupConfirma = false;
                vm.$swal("Erro ao aceitar", "Saldo insuficiente");
            });
        },

        aceitaSolicitacaoHorario(id, horario) {
            const vm = this;
            this.axios
            .put(
                vm.$store.state.filooServer +
                "schedules/" +
                id +
                "/accept-patient-horario/" +
                horario,
                {},
                {
                headers: {
                    Authorization: vm.$session.get("bearer")
                }
                }
            )
            .then(function(response) {
                if (response.status === 200) {
                    vm.$swal("Sucesso!", "Consulta aceita", "success");
                    vm.popupConfirma = false;
                    vm.getPendency();
                } else {
                    vm.popupConfirma = false;
                    vm.$swal("Erro ao aceitar", "Saldo insuficiente");
                }
            })
            .catch(function(error) {
                vm.popupConfirma = false;
                if (error.response.status === 418) {
                    vm.$swal(
                        "Erro ao aceitar",
                        "Horário solicitado é anterior ao horário atual."
                );
                } else if (error.response.status === 412) {
                    vm.$swal("Erro ao aceitar", "Saldo insuficiente.");
                } else {
                    vm.$swal("Erro ao aceitar", "Não foi possivel aceitar agora.");
                }
            });
        },

        cancel(indextr) {
            const vm = this;
            vm.cancellation = false;
            this.axios
            .put(
                vm.$store.state.filooServer + "schedules/" + indextr + "/cancel",
                "",
                {
                headers: {
                    Authorization: vm.$session.get("bearer")
                }
                }
            )
            .then(function(response) {
                if (response.status === 200) {
                    vm.$swal("Sucesso!", "Consulta cancelada", "success");
                    vm.getPendency();
                } else {
                    vm.popupConfirma = false;
                    vm.$swal("Erro ao cancelar", "error");
                }
            })
            .catch(function() {
                vm.popupConfirma = false;
                vm.$swal("Erro ao cancelar", "error");
            });
        }
    }
};
</script>
<style src="./SchedulePendency.css"></style>
